import dayjs from "dayjs";

import { PeriodOptionType, Timespan } from "./types";

export const DEFAULT_PERIOD_OPTION: PeriodOptionType = "last_28_days" as const;

export const PERIOD_OPTIONS = [
  "custom",
  "last_day",
  "last_7_days",
  "last_28_days",
  "last_18_months",
  "prev_month",
];

export const getTimespanFromPeriod = (period: PeriodOptionType): Timespan => {
  // To ensure data is available, we only show data up to one week ago.
  // This can be overridden by using the "custom" option, but may not be reliable.
  const now = dayjs();
  const sevenDaysAgo = now.subtract(7, "days");
  const prevMonth = now.subtract(1, "month");
  switch (period) {
    case "last_day":
      return {
        startDate: sevenDaysAgo.startOf("day").toDate(),
        endDate: sevenDaysAgo.endOf("day").toDate(),
      };
    case "last_7_days":
      return {
        startDate: sevenDaysAgo.subtract(6, "day").startOf("day").toDate(),
        endDate: sevenDaysAgo.endOf("day").toDate(),
      };

    case "last_28_days":
      return {
        startDate: sevenDaysAgo.subtract(27, "day").startOf("day").toDate(),
        endDate: sevenDaysAgo.endOf("day").toDate(),
      };
    case "last_18_months":
      return {
        startDate: sevenDaysAgo.subtract(18, "month").startOf("day").toDate(),
        endDate: sevenDaysAgo.endOf("day").toDate(),
      };
    case "prev_month":
      return {
        startDate: prevMonth.startOf("month").toDate(),
        endDate: prevMonth.endOf("month").toDate(),
      };
  }
  return {
    startDate: sevenDaysAgo.startOf("day").toDate(),
    endDate: sevenDaysAgo.endOf("day").toDate(),
  };
};
